import { useAtom } from 'jotai'
import { match } from 'ts-pattern'
import { PriceEditorDrawer } from './PriceEditorDrawer'
import { AnimatePresence } from 'framer-motion'
import { DiscountEditorDrawer } from './DiscountEditorDrawer'
import { MinimumEditorDrawer } from './MinimumEditorDrawer'
import { taskDrawerConfigAtom } from '../../../../../atoms'

export const ReviewPricingDrawers = () => {
  const [config, setConfig] = useAtom(taskDrawerConfigAtom)

  return (
    <AnimatePresence>
      {config &&
        match(config)
          .with({ type: 'PRICE' }, props => (
            <PriceEditorDrawer {...props} onDismiss={() => setConfig(null)} />
          ))
          .with({ type: 'DISCOUNT' }, props => (
            <DiscountEditorDrawer
              {...props}
              onDismiss={() => setConfig(null)}
            />
          ))
          .with({ type: 'MINIMUM' }, props => (
            <MinimumEditorDrawer {...props} onDismiss={() => setConfig(null)} />
          ))
          .exhaustive()}
    </AnimatePresence>
  )
}
